export default __webpack_public_path__ + "static/media/iconLungs.ef7b71e7.svg";